// Diamètres proposés uniquement : aucun choix ni coefficient de charge prérempli.
export const DIAMETRES_FRIGORIFIQUES = [
  ['1/4', '6.35'], ['3/8', '9.52'], ['1/2', '12.7'], ['5/8', '15.88'], ['3/4', '19.05'],
  ['7/8', '22.22'], ['1 1/8', '28.58'], ['1 3/8', '34.92'], ['1 5/8', '41.28'],
] as const;
export const AVERTISSEMENT_CHARGE = 'TRAME ne vérifie pas la concentration admissible dans les pièces (NF EN 378) : à vérifier par le référent.';
export interface DiametreFrigorifique { pouces: string; mm: string }
export interface Refrigeration {
  liquide: DiametreFrigorifique | null; gaz: DiametreFrigorifique | null;
  isolantMm: string | null; fluide: string | null; fabricant: string | null; gamme: string | null;
  uniteExterieure: string | null; unitesInterieures: string[];
  derivations: { point: number; reference: string | null }[];
}
export interface VerticalSpec {
  mode: 'manuel' | 'etages' | 'a_saisir'; metres: string | null; source: string | null; destinationPlanId: string | null;
}
export interface RegleCharge {
  id: string; manufacturer: string; range_name: string; fluid: string; liquid_mm: string; grams_per_m: string;
  fixed_grams_per_unit: string | null; source_document: string; source_page: number; source_date: string;
  validated_by: string | null; validated_at: string | null; updated_at: string;
}
